import Window from '@reverbdotcom/commons/dist/window_wrapper';
import { useUser } from '@reverbdotcom/commons/dist/user_hooks';

export enum AdyenCardType {
  Mastercard = 'mc',
  Visa = 'visa',
  Discover ='discover',
  Amex = 'amex',
  Card ='card', // generic fallback
}

const REVERB_TO_ADYEN_CARD_TYPE = {
  mastercard: 'mc',
  visa: 'visa',
  discover: 'discover',
  amex: 'amex',
};

export function reverbToAdyenCardType(cardType: string): AdyenCardType {
  if (!cardType) {
    return AdyenCardType.Card;
  }

  return REVERB_TO_ADYEN_CARD_TYPE[cardType.toLowerCase()];
}

export function useAdyenEnvironment() {
  if (Window.location.origin === 'https://reverb.com') {
    return { clientKey: 'live_ENJJ6UORDZHA5BA2LSFNU45Z4Q5VNQPN', environment: 'live' };
  }

  return { clientKey: 'test_WM7AVJNA2FG4JEXGKNZMUBXX6M4TVRIH', environment: 'test' };
}

export function useFiveDigitLocale() {
  const { locale, countryCode } = { locale: 'en', countryCode: 'US', ...useUser() };

  return [locale, countryCode].join('_');
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/lib/adyen.ts